import { CommonModule } from '@angular/common';
import {
  AgGridComponent,
  DwGridDataSourceService,
  FieldTypes,
  IEnumerationCellRendererParams,
  ListPageComponent,
} from '@digiwall/ag-grid';
import { Component, Injector, input } from '@angular/core';
import { LocalizationModule, LocalizationService, SubscriptionService } from '@abp/ng.core';
import {
  CustomerProjectListDto,
  CustomerProjectListRequestDto,
  CustomerProjectService,
} from '@digiwall/goliath-documents/proxy';
import { BaseCustomerDocList } from '../../base-customer-docs/base-customer-doc-list';
import { ColDef } from '@ag-grid-community/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from '@abp/ng.theme.shared';

@Component({
  selector: 'document-customer-project-list',
  templateUrl: './customer-project-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: [DwGridDataSourceService, SubscriptionService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class CustomerProjectListComponent extends BaseCustomerDocList<
  CustomerProjectListDto,
  CustomerProjectService
> {
  customerId = input<string>();
  showCreationBtn = input<boolean>(true);
  showToolbar = input<boolean>(true);

  private _columns: ColDef[] = [
    ...this.colDefs,
    {
      field: 'projectStatus',
      headerName: this.localizationService.instant('Doc::QuoteStatus'),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.documentEnumerationTypeStore.projectStatus,
      } as IEnumerationCellRendererParams,
    },
  ];

  get columns(): ColDef[] {
    return this._columns;
  }

  constructor(
    protected service: CustomerProjectService,
    router: Router,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    confirmation: ConfirmationService,
    datasource: DwGridDataSourceService,
    injector: Injector,
  ) {
    super(
      service,
      router,
      route,
      localizationService,
      subscriptionService,
      confirmation,
      datasource,
      injector,
    );
  }

  protected override getQueryObservable() {
    const baseObservable = super.getQueryObservable();
    return (query: CustomerProjectListRequestDto) => {
      if (this.customerId()) {
        query.thirdPartyId = this.customerId();
      }
      return baseObservable(query);
    };
  }

  protected override getBasePath(): string | null {
    return '/documents/customer-projects/';
  }

  protected override editEntity(entity: CustomerProjectListDto) {
    if (this.customerId()) {
      const url = this.getBasePath() + entity.id;
      window.open(url, '_blank');
    } else {
      super.editEntity(entity);
    }
  }
}
